import React, { useState, useEffect } from 'react'
import {
  Typography,
  Button,
  TextField,
  Alert
} from '@mui/material'

import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'


import { useDispatch, useSelector } from 'react-redux'
import { login } from '../actions/userActions'


const LoginCard = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  })

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { error, userInfo } = useSelector(state => state.userState)

  useEffect(() => {
    if (userInfo && userInfo.token) {
      navigate('/profile')
    }
  }, [navigate, userInfo])

  const submitHandler = e => {
    e.preventDefault()
    dispatch(login(formData.email, formData.password))
  }

  const changeField = e => setFormData({ ...formData, [e.target.name]: e.target.value })

  return (
    <>
      <Typography sx={{ mb: 3 }} variant='h6'>Login</Typography>
      {error && <Alert sx={{ mb: 3 }} severity='error'>{error}</Alert>}
      <form onSubmit={submitHandler}>
        <TextField
          label='Email'
          name='email'
          fullWidth
          sx={{ mb: 3 }}
          value={formData.email}
          onChange={changeField}
        />
        <TextField
          label='Password'
          name='password'
          type='password'
          fullWidth
          sx={{ mb: 3 }}
          value={formData.password}
          onChange={changeField}
        />
        <Button variant='contained' type='submit' sx={{ mb: 2 }} fullWidth>Login</Button>
      </form>
      <Typography variant='body1' color='primary'>
        <Link to='/forgot-password' style={{ color: 'inherit' }}>Forgot your password?</Link>
      </Typography>
    </>
  )
}

export default LoginCard